import React, { Component } from 'react';
import styled from '@emotion/styled';

const Li = styled.li`
  display: inline;
  margin: 0;
  padding: 0;
  &:after {
    display: inline-block;
    content: '>';
    margin: 0 0.2em 0 0.1em;
  }
  &:last-child:after {
    display: none;
    content: '';
  }
`;

class BreadcrumbItem extends Component {
  render() {
    return <Li active={this.props.active}>{this.props.children}</Li>;
  }
}

BreadcrumbItem.A = styled.a`
  text-decoration: none;
  color: ${props => props.theme.lightColor};
  font-weight: bold;
  @media print {
    color: ${props => props.theme.textColor};
  }
`;

export default BreadcrumbItem;
